export default __webpack_public_path__ + "static/media/logoKLDXRed.c942ca6a.png";